import { createContext, useContext } from 'react';
export const SlateContext = createContext({
    mode: 'live',
    slate: null,
    compiledSlate: null,
    context: null,
    extraContext: { slate: {}, blocks: {} },
});
export const useSlate = () => {
    const context = useContext(SlateContext);
    return context;
};
//# sourceMappingURL=slate.hook.js.map